// Format city values
export const formatCities = (cities) => {
  return cities?.map((city) => ({
    label: city.city_name,
    value: city.city_id,
  }));
};

// Format country values
export const formatCountries = (countries) => {
  return countries?.map((country) => ({
    label: country.name,
    value: country.country_id,
  }));
};

// Format country values
export const formatJobTitles = (jobTitles) => {
  return jobTitles?.map((title) => ({
    label: title.designation_name,
    value: title.id,
  }));
};
